var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay-page"},[_c('b-spinner',{staticClass:"align-middle-page-loading",attrs:{"scale":"5"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }